// Reference: https://github.com/facebook/lexical/blob/main/packages/lexical-playground/src/plugins/AutoLinkPlugin/index.tsx
import { $isAutoLinkNode, AutoLinkNode } from "@lexical/link"
import {
  AutoLinkPlugin,
  createLinkMatcherWithRegExp,
} from "@lexical/react/LexicalAutoLinkPlugin"
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext"
import { $getNodeByKey } from "lexical"
import { useEffect, useRef } from "react"

const URL_REGEX =
  /((https?:\/\/(www\.)?)|(www\.))[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/

const EMAIL_REGEX =
  /(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/

const MATCHERS = [
  createLinkMatcherWithRegExp(URL_REGEX, (text) => {
    return text.startsWith("http") ? text : `https://${text}`
  }),
  createLinkMatcherWithRegExp(EMAIL_REGEX, (text) => {
    return `mailto:${text}`
  }),
]

export default function LexicalAutoLinkPlugin(): JSX.Element {
  const [editor] = useLexicalComposerContext()
  const processedNodeKeys = useRef(new Set<string>())

  useEffect(() => {
    if (!editor) return

    processedNodeKeys.current = new Set<string>()

    const removeNodeListener = editor.registerMutationListener(
      AutoLinkNode,
      (mutatedNodes) => {
        mutatedNodes.forEach((mutation, nodeKey) => {
          // Use processedNodeKeys to ensure we only set target="_blank" on newly created auto-links
          if (mutation === "created" && !processedNodeKeys.current.has(nodeKey)) {
            setTimeout(() => {
              if (processedNodeKeys.current.has(nodeKey)) {
                return
              }
              editor.update(() => {
                const node = $getNodeByKey(nodeKey)
                if ($isAutoLinkNode(node)) {
                  processedNodeKeys.current.add(nodeKey)
                  node.setTarget("_blank")
                }
              })
            }, 0)
          }
        })
      }
    )

    return () => removeNodeListener()
  }, [editor])

  return <AutoLinkPlugin matchers={MATCHERS} />
}
